import { useLocation, useParams } from "react-router-dom";
import style from "./MachineManagement.module.css";
import { useEffect, useState } from "react";
import { requester } from "App";
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Center from "layouts/wrapper/Center";
import VerticalFlex from "layouts/flex/VerticalFlex";
import CustomButton from "components/buttons/CustomButton";
import Dummy from "components/Dummy";
import { toast } from "react-toastify";
import Container from "layouts/container/Container";
import clsx from "classnames";

function MachineManagement() {
    const location = useLocation();
    const { machineId } = useParams();
    const [storeProducts, setStoreProducts] = useState([]);
    const [machineType, setMachineType] = useState(location.state?.data?.machineType || "");
    const [cells, setCells] = useState(Array(80).fill(null));
    const [vendingName, setVendingName] = useState();
    const [placedItems, setPlacedItems] = useState([]);
    const [viewSection, setViewSection] = useState("door"); // "door" or "inside" for HOLDER type

    // Define cell configurations for both machine types
    const holderCells = {
        door: [
            21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35,
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15
        ],
        inside: [
            61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75,
            41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55
        ]
    };
    
    const springCells = [
        10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20, 21, 22, 23, 24, 25, 26, 27, 28, 29,
        30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
        40, 41, 42, 43, 44, 45, 46, 47, 48, 49,
        50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
        60, 62, 64, 66, 68
    ];
    
    useEffect(() => {
        if (location.state?.data?.storeId) {
            console.log(location.state.data);
            const data = { storeId: location.state.data.storeId };
            const currentMachineId = location.state.data.id;
            const machineType = location.state.data.machineType;
            setVendingName(location.state.data.vendingName);
            setMachineType(machineType);
            
            requester.findAllProductsByStore(data, (result) => {
                if (result.data && result.data.length > 0) {
                    const filteredProducts = result.data.filter(product => product.machineId === currentMachineId);
                    const otherProducts = result.data.filter(product => product.machineId === null);
                    setStoreProducts(otherProducts);
                    
                    let initialCells = Array(80).fill(null);
                    filteredProducts.forEach(product => {
                        if (product.locationNo !== null && product.locationNo <= initialCells.length) {
                            initialCells[product.locationNo - 1] = product;
                        }
                    });
                    setCells(initialCells);
                    if (filteredProducts.length > 0) {
                        setPlacedItems(filteredProducts);
                    }
                }
            });
        }
    }, [location]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [viewSection]);

    useEffect(() => {
        if (placedItems) {
            console.log("placedItems", placedItems);
        }
    }, [placedItems]);

    const onDragEnd = (result) => {
        const { source, destination } = result;
        if (!destination) return;

        if (machineType === "기계 타입을 선택하세요") {
            toast.error("상품을 이동하기 전에 기계 타입을 선택해주세요.", {
                autoClose: 3000,
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        if (source.droppableId === destination.droppableId && source.index === destination.index) {
            return;
        }

        let newCells = [...cells];
        let newStoreProducts = [...storeProducts];

        // 셀에서 셀로 이동
        if (source.droppableId.startsWith("cell") && destination.droppableId.startsWith("cell")) {
            const sourceIndexGlobal = parseInt(source.droppableId.replace("cell-", ''), 10);
            const destIndexGlobal = parseInt(destination.droppableId.replace("cell-", ''), 10);

            [newCells[sourceIndexGlobal], newCells[destIndexGlobal]] = [newCells[destIndexGlobal], newCells[sourceIndexGlobal]];

            // 위치 변경 로직
            const updatedPlacedItems = placedItems.map(item => {
                if (item.locationNo === sourceIndexGlobal + 1) {
                    return { ...item, locationNo: destIndexGlobal + 1 };
                } else if (item.locationNo === destIndexGlobal + 1) {
                    return { ...item, locationNo: sourceIndexGlobal + 1 };
                }
                return item;
            });

            setPlacedItems(updatedPlacedItems);
        }
        // 미등록에서 셀로 이동
        else if (source.droppableId === "unregisteredItems" && destination.droppableId.startsWith("cell")) {
            const destIndex = parseInt(destination.droppableId.replace("cell-", ''), 10);
            const draggedItem = newStoreProducts[source.index];

            // 목적지 셀에 이미 상품이 있는 경우, 그 상품을 미등록 목록으로 이동
            if (newCells[destIndex]) {
                newStoreProducts.push(newCells[destIndex]);
            }
            
            // 새 위치에 드래그된 아이템을 할당
            newCells[destIndex] = draggedItem;
            
            // 드래그된 아이템을 미등록 목록에서 제거
            newStoreProducts.splice(source.index, 1);
            
            setPlacedItems(currentItems => {
                if (!Array.isArray(currentItems)) {
                    return [];
                }
                return [
                    ...currentItems.filter(item => item.locationNo !== destIndex + 1),
                    { ...draggedItem, locationNo: destIndex + 1, machineId: machineId, machineType: machineType }
                ];
            });
        }
        // 셀에서 미등록으로 이동
        else if (source.droppableId.startsWith("cell") && destination.droppableId === "unregisteredItems") {
            const sourceIndex = parseInt(source.droppableId.replace("cell-", ''), 10);
            const movedItem = newCells[sourceIndex];
            
            // 목적지(미등록)에 아이템 추가
            newStoreProducts.push(movedItem);
            const updatedPlacedItems = placedItems.filter(item => item.id !== movedItem.id);
            setPlacedItems(updatedPlacedItems);
            newCells[sourceIndex] = null;
        }

        setCells(newCells);
        setStoreProducts(newStoreProducts);
    };

    // 아이템을 렌더링하는 함수
    const renderCellItem = (item, index) => {
        if (!item) return null;

        return (
            <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                {(provided) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className={style.draggableItem}
                    >
                        <Center>
                            <img src={item.productImg} alt={item.productName} style={{ maxHeight: "100px" }} />
                            <p>{item.productName}</p>
                        </Center>
                    </div>
                )}
            </Draggable>
        );
    };

    const updateClick = () => {
        if (!machineType) {
            toast.error("기계의 타입을 선택해주세요", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
        } else {
            let machineData = { machineId: machineId, storeProducts: placedItems };
            requester.mappingMachineProductList(machineData, (result) => {
                if (result.code === 0) {
                    toast.success("수정이 완료되었습니다", {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                } else {
                    toast.error("스토어 머신에 중복된 상품을 넣을 수 없습니다.", {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                }
            });
        }
    };

    // Get visible cells based on machine type and view section
    const getVisibleCells = () => {
        if (machineType === "HOLDER") {
            return viewSection === "door" ? holderCells.door : holderCells.inside;
        } else if (machineType === "SPRING") {
            // For SPRING type, show all cells at once
            return springCells;
        }
        return [];
    };

    // Render cells in a grid layout based on machine type
    const renderCells = () => {
        const visibleCells = getVisibleCells();
        
        if (machineType === "HOLDER") {
            // For HOLDER, we render in a 15x2 grid (2 rows, 15 columns)
            return (
                <div className={style.holderGrid}>
                    {visibleCells.map((cellNumber, index) => {
                        const cellIndex = cellNumber - 1;
                        const cell = cells[cellIndex];
                        
                        return (
                            <Droppable key={cellIndex} droppableId={`cell-${cellIndex}`}>
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        className={style.holderCell}
                                    >
                                        <P>{cellNumber}</P>
                                        {cell && renderCellItem(cell, index)}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        );
                    })}
                </div>
            );
        } else if (machineType === "SPRING") {
            // For SPRING, we render in a 10x5 grid plus a special bottom row
            const regularCells = visibleCells.slice(0, 50); // First 50 cells (5 rows of 10)
            const specialRowCells = visibleCells.slice(50); // Last row with special cells
            
            return (
                <div className={style.springContainer}>
                    <div className={style.springGrid}>
                        {regularCells.map((cellNumber, index) => {
                            const cellIndex = cellNumber - 1;
                            const cell = cells[cellIndex];
                            
                            return (
                                <Droppable key={cellIndex} droppableId={`cell-${cellIndex}`}>
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            className={style.springCell}
                                        >
                                            <P>{cellNumber}</P>
                                            {cell && renderCellItem(cell, index)}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            );
                        })}
                    </div>
                    
                    {specialRowCells.length > 0 && (
                        <div className={style.springSpecialRow}>
                            {specialRowCells.map((cellNumber, index) => {
                                const cellIndex = cellNumber - 1;
                                const cell = cells[cellIndex];
                                
                                return (
                                    <Droppable key={cellIndex} droppableId={`cell-${cellIndex}`}>
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                className={style.springSpecialCell}
                                            >
                                                <P>{cellNumber}</P>
                                                {cell && renderCellItem(cell, index)}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                );
                            })}
                        </div>
                    )}
                </div>
            );
        }
        
        return null;
    };

    // Toggle view section for HOLDER machine type
    const toggleViewSection = (section) => {
        setViewSection(section);
    };

    return (
        <Container>
            <Container maxWidth={1800}>
                <Center width={"100%"} textAlign={"left"}>
                    <P size={40} font={"gmarketSansBold"} color={"black"}>{vendingName && vendingName}</P>
                </Center>
                <P size={20} weight={"bold"}>{`기계 타입 : ${machineType}`}</P>
                
                <DragDropContext onDragEnd={onDragEnd}>
                    <HorizontalFlex>
                        <FlexChild width="20%">
                            <VerticalFlex>
                                {/* 미등록 영역 */}
                                <P size={16} weight={"bold"}>미등록 상품</P>
                                <FlexChild>
                                    <Droppable droppableId="unregisteredItems">
                                        {(provided) => (
                                            <div {...provided.droppableProps} ref={provided.innerRef} className={style.droppableContainer}>
                                                {storeProducts.map((item, index) => renderCellItem(item, index))}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>

                        {/* 셀 영역 */}
                        <FlexChild width="80%">
                            <VerticalFlex gap={15}>
                                {/* 뷰 전환 버튼 */}
                                <div className={style.viewToggle}>
                                    {machineType === "HOLDER" ? (
                                        <>
                                            <CustomButton 
                                                text={"문"} 
                                                onClick={() => toggleViewSection("door")}
                                                className={viewSection === "door" ? style.activeButton : ""}
                                            />
                                            <CustomButton 
                                                text={"내부"} 
                                                onClick={() => toggleViewSection("inside")}
                                                className={viewSection === "inside" ? style.activeButton : ""}
                                            />
                                        </>
                                    ) : null}
                                </div>
                                
                                {/* 셀 그리드 */}
                                <div className={style.cellsContainer}>
                                    {renderCells()}
                                </div>
                            </VerticalFlex>
                        </FlexChild>
                    </HorizontalFlex>
                </DragDropContext>
                
                <Dummy height={"15px"} />
                <FlexChild>
                    <Center>
                        <CustomButton text={"적용"} onClick={updateClick} />
                    </Center>
                </FlexChild>
            </Container>
        </Container>
    );
}

export default MachineManagement;